// extracted by mini-css-extract-plugin
export default {"noPhoto":"NoPhoto_noPhoto__8SMwm","wrapper":"NoPhoto_wrapper__Ca7R9"};